import {
    API_TOKEN,
    SET_USER,
    LOGOUT_USER,
    // PURGE,
    CHANGE_SETTING,
    SET_MESSAGES, READ_MESSAGE, UPDATE_USER, RESET_COMPLAIN, UPDATE_COMPLAIN, ADD_COMPLAIN, UPDATE_FOOTER
} from "./type";
//import { purgeStoredState  } from 'redux-persist';

export function setUser(user) {
    return {
        type: SET_USER,
        user
    };
}

export function updateUser(newUser) {
    return {
        type: UPDATE_USER,
        newUser
    };
}

export function logoutUser() {
    removeToken();
    return {
        type: LOGOUT_USER,
    };
}
export function setToken(api_token) {
    localStorage.setItem(API_TOKEN, api_token);
}

export function removeToken() {
    localStorage.removeItem(API_TOKEN);
}

export function loadToken() {
    return localStorage.getItem(API_TOKEN);
}


/*export const purgeStorage = () => ({
    type : PURGE,
});
export async function purgeStorage2() {
    return await purgeStoredState();
}
*/

export const changeSetting = (setting) => ({
    type : CHANGE_SETTING,
    setting : setting
});

export const setMessages = (messages) => ({
    type : SET_MESSAGES,
    messages
});
export const readMessage = (id) => ({
    type : READ_MESSAGE,
    id : id
});

export const addComplain = (complain) => ({
    type : ADD_COMPLAIN,
    complain
});


export const updateComplain = (comp) => ({
    type : UPDATE_COMPLAIN,
    comp
});


export const resetComplain = () => ({
    type : RESET_COMPLAIN,
});

export const updateFooter = (data, lastUpdate) => ({
    type : UPDATE_FOOTER,
    data,
    lastUpdate
});

/*
export const correctChart= (data, symbol)=>{
    let asset = getAsset(symbol);
    let pip = parseFloat(asset.pip);
    let minimum = data.reduce((min, point) => (point.bid < min) ? point.bid : min, data[0].bid);
    minimum = minimum - 2*pip;
    let output = data.map((item) => {
       return {
           "value": item.ask - minimum,
           "ask": item.ask,
           "bid": item.bid,
           "date": item.unixtime,
           "lo": minimum
       };
   });

   return output;
};
*/
